import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';

export default function AuthCallback({ onAuthSuccess }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const response = await axios.get(`${API}/auth/session-data`, {
          headers: { 'X-Session-ID': sessionId }
        });

        // Store token if provided
        if (response.data.session_token) {
          localStorage.setItem('token', response.data.session_token);
        }

        // Call success callback
        if (onAuthSuccess) {
          await onAuthSuccess(response.data);
        }

        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { state: { user: response.data } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, onAuthSuccess]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#00FF94] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white/60 font-mono">Authenticating...</p>
      </div>
    </div>
  );
}
